<script lang="ts">
    import T from "@components/T.svelte";

    export let errors: string[];
    export let namespace: string | undefined;
</script>

{#if errors.length}
    <ul class="gw-form-layout-item__error-list gw-list-reset-default-styles">
        {#each errors as error}
            <li class="gw-form-layout-item__error-item">
                {#if namespace}
                    <T {namespace} translationKey={error} />
                {:else}
                    {error}
                {/if}
            </li>
        {/each}
    </ul>
{/if}

<style>
    .gw-form-layout-item__error-list {
        font-size: 14px;
        color: #f04438;
    }
</style>
